import env from "@/config/env";

// Real authentication client backed by the KHA Auth mu-plugin on WordPress
// (kha/v1 REST namespace). Tokens are signed JWTs (HS256, wp_salt) issued by
// the backend; passwords are hashed by WordPress core (wp_hash_password).

const TOKEN_KEY = "kha_jwt";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

const base = () => `${(env.woo.storeApiUrl || "").replace(/\/wc\/store\/v1\/?$/, "")}`.replace(/\/wp-json\/?$/, "") + "/wp-json/kha/v1";

async function api(path, { method = "GET", body, auth = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth || getToken()) headers.Authorization = `Bearer ${getToken()}`;
  let res;
  try {
    res = await fetch(base() + path, { method, headers, body: body ? JSON.stringify(body) : undefined });
  } catch {
    throw { code: "network", message: "Cannot reach the server. Check your connection." };
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw { code: data.code || "error", message: data.message || `Request failed (${res.status})` };
  return data;
}

export async function login(email, password) {
  const d = await api("/login", { method: "POST", body: { email, password } });
  setToken(d.token);
  return d;
}
export async function register(name, email, password) {
  const d = await api("/register", { method: "POST", body: { name, email, password } });
  setToken(d.token);
  return d;
}
export async function forgotPassword(email) {
  return api("/forgot", { method: "POST", body: { email } });
}
export async function resetPassword(email, key, password) {
  const d = await api("/reset", { method: "POST", body: { email, key, password } });
  setToken(d.token);
  return d;
}
export async function me() {
  return api("/me", { auth: true });
}
export async function updateProfile(payload) {
  return api("/profile", { method: "POST", body: payload, auth: true });
}
export async function googleUrl() {
  return api("/auth/google/url");
}
export function logout() {
  setToken("");
}
